import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b78ae5b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-field" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col--9" }
const _hoisted_4 = {
  key: 0,
  class: "col--3 confirm-field__options"
}
const _hoisted_5 = {
  key: 1,
  class: "col--3 confirm-field__options"
}
const _hoisted_6 = {
  key: 2,
  class: "col--12"
}
const _hoisted_7 = { class: "input-field__error" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 3,
  class: "col--12 confirm-field__second"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseRadio = _resolveComponent("BaseRadio")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_InsuranceConfirmField = _resolveComponent("InsuranceConfirmField", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t(`checkout.insurance.${_ctx.InsuranceConfirmationEnum[_ctx.type]}`)), 1),
      (!_ctx.isCheckbox)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_BaseRadio, {
              id: `${_ctx.type}-1`,
              name: `${_ctx.type}`,
              label: "Yes",
              value: true,
              modelValue: _ctx.confirmInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmInput) = $event))
            }, null, 8, ["id", "name", "modelValue"]),
            _createVNode(_component_BaseRadio, {
              id: `${_ctx.type}-2`,
              name: `${_ctx.type}`,
              label: "No",
              value: false,
              modelValue: _ctx.confirmInput,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmInput) = $event))
            }, null, 8, ["id", "name", "modelValue"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_BaseCheckbox, {
              id: `${_ctx.type}-1`,
              name: `${_ctx.type}`,
              modelValue: _ctx.confirmInput,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmInput) = $event)),
              label: "I confirm"
            }, null, 8, ["id", "name", "modelValue"])
          ])),
      (_ctx.v$.confirmed.$errors.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.confirmed.$errors, (error) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: error,
                  innerHTML: error.$message
                }, null, 8, _hoisted_8))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.secondType && _ctx.confirmInput)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_InsuranceConfirmField, { type: _ctx.secondType }, null, 8, ["type"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}